import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { getVmsDefaultLandingPath } from '../utils/vmsRole';
import { canAccessFlowStakeholders } from '../utils/flowStakeholdersAccess';
import { PageLoader } from './LoadingStates';

/** Flow stakeholders: business owner or VMS admin (governance). */
const VmsBusinessOwnerRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { user, loading } = useAuth();
  if (loading) {
    return <PageLoader message="Loading..." />;
  }
  if (!canAccessFlowStakeholders(user)) {
    return <Navigate to={getVmsDefaultLandingPath(user)} replace />;
  }
  return <>{children}</>;
};

export default VmsBusinessOwnerRoute;
